<mat-horizontal-stepper [linear]="true" #stepper>

    <mat-step [stepControl]="projectIdentificationForm">
        <form [formGroup]="projectIdentificationForm">
            <ng-template matStepLabel>Project Identification</ng-template>

            <div class="form-section">
                <div class="form-row">
                    <!-- Project Name/ID -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Project Name/ID</mat-label>
                        <input matInput formControlName="projectName" />
                        <mat-error *ngIf="projectIdentificationForm.get('projectName')?.hasError('required')">
                            Project Name/ID is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Project Type -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Project Type</mat-label>
                        <mat-select formControlName="projectType">
                            <mat-option value="New construction">New construction</mat-option>
                            <mat-option value="Expansion">Expansion</mat-option>
                            <mat-option value="Rehabilitation">Rehabilitation</mat-option>
                        </mat-select>
                        <mat-error *ngIf="projectIdentificationForm.get('projectType')?.hasError('required')">
                            Project Type is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <!-- Location/Geography -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Location/Geography</mat-label>
                        <textarea matInput formControlName="location"></textarea>
                        <mat-error *ngIf="projectIdentificationForm.get('location')?.hasError('required')">
                            Location is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Road Classification -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Road Classification</mat-label>
                        <mat-select formControlName="roadClassification">
                            <mat-option value="National Highway">National Highway</mat-option>
                            <mat-option value="State Highway">State Highway</mat-option>
                            <mat-option value="Major District Road">Major District Road</mat-option>
                            <mat-option value="Other District Road">Other District Road</mat-option>
                            <mat-option value="Village Road">Village Road</mat-option>
                        </mat-select>
                        <mat-error *ngIf="projectIdentificationForm.get('roadClassification')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <!-- Project Stage -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Project Stage</mat-label>
                        <mat-select formControlName="projectStage">
                            <mat-option value="DPR">DPR</mat-option>
                            <mat-option value="Tendering">Tendering</mat-option>
                            <mat-option value="Construction">Construction</mat-option>
                            <mat-option value="Handover">Handover</mat-option>
                        </mat-select>
                        <mat-error *ngIf="projectIdentificationForm.get('projectStage')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <!-- Project Timeline -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Project Timeline</mat-label>
                        <input matInput placeholder="Start - Completion" formControlName="timeline" />
                        <mat-error *ngIf="projectIdentificationForm.get('timeline')?.hasError('required')">
                            Project timeline is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <!-- Project Owner/Authority -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Project Owner/Authority</mat-label>
                        <mat-select formControlName="projectOwner">
                            <mat-option value="NHAI">NHAI</mat-option>
                            <mat-option value="PWD">PWD</mat-option>
                            <mat-option value="PMGSY">PMGSY</mat-option>
                            <mat-option value="BRO">BRO</mat-option>
                        </mat-select>
                        <mat-error *ngIf="projectIdentificationForm.get('projectOwner')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <!-- Project Scheme -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Project Scheme</mat-label>
                        <mat-select formControlName="projectScheme">
                            <mat-option value="PMGSY">PMGSY</mat-option>
                            <mat-option value="PMGSY-III">PMGSY-III</mat-option>
                            <mat-option value="Bharatmala">Bharatmala</mat-option>
                            <mat-option value="NHDP">NHDP</mat-option>
                            <mat-option value="CRIF">CRIF</mat-option>
                            <mat-option value="State Plan">State Plan</mat-option>
                        </mat-select>
                        <mat-error *ngIf="projectIdentificationForm.get('projectScheme')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-actions">
                <button mat-raised-button matStepperNext color="primary" [disabled]="!projectIdentificationForm.valid">Next</button>
            </div>
        </form>
    </mat-step>


    <mat-step [stepControl]="roadSpecificationsForm">
        <form [formGroup]="roadSpecificationsForm">
            <ng-template matStepLabel>Road Specifications</ng-template>

            <div class="form-section">
                <div class="form-row">
                    <!-- Road Length (km) -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Road Length (km)</mat-label>
                        <input matInput type="number" formControlName="roadLength" />
                        <mat-error *ngIf="roadSpecificationsForm.get('roadLength')?.hasError('required')">
                            Road length is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Number of Lanes -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Number of Lanes</mat-label>
                        <mat-select formControlName="numberOfLanes">
                            <mat-option *ngFor="let n of [1,2,3,4,5,6]" [value]="n">{{n}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="roadSpecificationsForm.get('numberOfLanes')?.hasError('required')">
                            Number of lanes is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <!-- Lane Width (meters) -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Lane Width (meters)</mat-label>
                        <input matInput type="number" formControlName="laneWidth" />
                        <mat-error *ngIf="roadSpecificationsForm.get('laneWidth')?.hasError('required')">
                            Lane width is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Road Surface Type -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Road Surface Type</mat-label>
                        <mat-select formControlName="surfaceType">
                            <mat-option value="Asphalt/Bituminous">Asphalt/Bituminous</mat-option>
                            <mat-option value="Concrete/Cement">Concrete/Cement</mat-option>
                            <mat-option value="WBM">WBM</mat-option>
                            <mat-option value="PMGSY Standards">PMGSY Standards</mat-option>
                        </mat-select>
                        <mat-error *ngIf="roadSpecificationsForm.get('surfaceType')?.hasError('required')">
                            Surface type is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <!-- Design Speed -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Design Speed (km/hr)</mat-label>
                        <input matInput type="number" formControlName="designSpeed" />
                        <mat-error *ngIf="roadSpecificationsForm.get('designSpeed')?.hasError('required')">
                            Design speed is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Traffic Volume -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Traffic Volume (PCU)</mat-label>
                        <input matInput type="number" formControlName="trafficVolume" />
                        <mat-error *ngIf="roadSpecificationsForm.get('trafficVolume')?.hasError('required')">
                            Traffic volume is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <!-- Design Life -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>Design Life (years)</mat-label>
                        <input matInput type="number" formControlName="designLife" />
                        <mat-error *ngIf="roadSpecificationsForm.get('designLife')?.hasError('required')">
                            Design life is required
                        </mat-error>
                    </mat-form-field>

                    <!-- IRC Code Compliance -->
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>IRC Code Compliance Details</mat-label>
                        <textarea matInput rows="3" formControlName="ircCompliance"></textarea>
                        <mat-error *ngIf="roadSpecificationsForm.get('ircCompliance')?.hasError('required')">
                            IRC details are required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!roadSpecificationsForm.valid">Next</button>
            </div>
        </form>
    </mat-step>
    
    <mat-step [stepControl]="siteConditionsForm">
        <form [formGroup]="siteConditionsForm">
            <ng-template matStepLabel>Site Conditions</ng-template>

            <!-- Terrain Type -->
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Terrain Type</mat-label>
                <mat-select formControlName="terrainType">
                    <mat-option value="Plain">Plain</mat-option>
                    <mat-option value="Rolling">Rolling</mat-option>
                    <mat-option value="Mountainous">Mountainous</mat-option>
                    <mat-option value="High Altitude/Cold Regions">High Altitude/Cold Regions</mat-option>
                </mat-select>
                <mat-error *ngIf="siteConditionsForm.get('terrainType')?.hasError('required')">Required</mat-error>
            </mat-form-field>

            <!-- Soil Classification Section -->
            <h3>Soil Classification</h3>
            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Soil Type</mat-label>
                    <mat-select formControlName="soilType">
                        <mat-option value="Black Cotton Soil">Black Cotton Soil</mat-option>
                        <mat-option value="Lateritic">Lateritic</mat-option>
                        <mat-option value="Alluvial">Alluvial</mat-option>
                        <mat-option value="Other">Other</mat-option>
                    </mat-select>
                    <mat-error *ngIf="siteConditionsForm.get('soilType')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>CBR Value (%)</mat-label>
                    <input matInput type="number" formControlName="cbrValue" />
                    <mat-error *ngIf="siteConditionsForm.get('cbrValue')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Plasticity Index</mat-label>
                    <input matInput type="number" formControlName="plasticityIndex" />
                    <mat-error
                        *ngIf="siteConditionsForm.get('plasticityIndex')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Moisture Content (%)</mat-label>
                    <input matInput type="number" formControlName="moistureContent" />
                    <mat-error
                        *ngIf="siteConditionsForm.get('moistureContent')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <!-- Hydrological Data -->
            <h3>Hydrological Data</h3>
            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Monsoon Pattern</mat-label>
                    <mat-select formControlName="monsoonPattern">
                        <mat-option value="Southwest">Southwest</mat-option>
                        <mat-option value="Northeast">Northeast</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="siteConditionsForm.get('monsoonPattern')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Annual Rainfall (mm)</mat-label>
                    <input matInput type="number" formControlName="annualRainfall" />
                    <mat-error
                        *ngIf="siteConditionsForm.get('annualRainfall')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Flood History</mat-label>
                    <input matInput formControlName="floodHistory" />
                    <mat-error *ngIf="siteConditionsForm.get('floodHistory')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Water Table Level (m)</mat-label>
                    <input matInput type="number" formControlName="waterTableLevel" />
                    <mat-error
                        *ngIf="siteConditionsForm.get('waterTableLevel')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <!-- Environmental Conditions -->
            <h3>Environmental Conditions</h3>
            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Temperature Range (°C)</mat-label>
                    <input matInput formControlName="temperatureRange" />
                    <mat-error
                        *ngIf="siteConditionsForm.get('temperatureRange')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Frost Susceptibility</mat-label>
                    <mat-select formControlName="frostSusceptibility">
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="siteConditionsForm.get('frostSusceptibility')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Coastal Area Considerations</mat-label>
                <textarea matInput rows="2" formControlName="coastalConsiderations"></textarea>
                <mat-error
                    *ngIf="siteConditionsForm.get('coastalConsiderations')?.hasError('required')">Required</mat-error>
            </mat-form-field>

            <!-- Navigation Buttons -->
            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button matStepperNext color="primary" [disabled]="!siteConditionsForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="designParametersForm">
        <form [formGroup]="designParametersForm">
            <ng-template matStepLabel>Design Parameters</ng-template>

            <!-- Pavement Design -->
            <h3>Pavement Design</h3>
            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Pavement Type</mat-label>
                    <mat-select formControlName="pavementType">
                        <mat-option value="Flexible">Flexible</mat-option>
                        <mat-option value="Rigid">Rigid</mat-option>
                        <mat-option value="Composite">Composite</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="designParametersForm.get('pavementType')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Layer Thicknesses (mm)</mat-label>
                    <input matInput type="text" formControlName="layerThicknesses" />
                    <mat-error
                        *ngIf="designParametersForm.get('layerThicknesses')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Material Specifications (MORTH)</mat-label>
                <textarea matInput rows="2" formControlName="materialSpecs"></textarea>
                <mat-error *ngIf="designParametersForm.get('materialSpecs')?.hasError('required')">Required</mat-error>
            </mat-form-field>

            <!-- Geometric Design -->
            <h3>Geometric Design</h3>
            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Horizontal Alignment (IRC:SP:73)</mat-label>
                    <input matInput type="text" formControlName="horizontalAlignment" />
                    <mat-error
                        *ngIf="designParametersForm.get('horizontalAlignment')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Vertical Alignment</mat-label>
                    <input matInput type="text" formControlName="verticalAlignment" />
                    <mat-error
                        *ngIf="designParametersForm.get('verticalAlignment')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Super-elevation (%)</mat-label>
                    <input matInput type="number" formControlName="superElevation" />
                    <mat-error
                        *ngIf="designParametersForm.get('superElevation')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Sight Distance (m)</mat-label>
                    <input matInput type="number" formControlName="sightDistance" />
                    <mat-error
                        *ngIf="designParametersForm.get('sightDistance')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <!-- Drainage Design -->
            <h3>Drainage Design</h3>
            <div class="form-row">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Side Drains</mat-label>
                    <input matInput type="text" formControlName="sideDrains" />
                    <mat-error *ngIf="designParametersForm.get('sideDrains')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Cross Drainage Structures</mat-label>
                    <input matInput type="text" formControlName="crossDrainageStructures" />
                    <mat-error
                        *ngIf="designParametersForm.get('crossDrainageStructures')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Culverts and Bridges</mat-label>
                <textarea matInput rows="2" formControlName="culvertsBridges"></textarea>
                <mat-error
                    *ngIf="designParametersForm.get('culvertsBridges')?.hasError('required')">Required</mat-error>
            </mat-form-field>

            <!-- Navigation -->
            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!designParametersForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="legalComplianceForm">
        <form [formGroup]="legalComplianceForm">
            <ng-template matStepLabel>Legal & Compliance</ng-template>

            <!-- Land Acquisition -->
            <h3>Land Acquisition Status</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Land Required (hectares)</mat-label>
                    <input matInput type="number" formControlName="landRequired" />
                    <mat-error
                        *ngIf="legalComplianceForm.get('landRequired')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Land Acquired (hectares)</mat-label>
                    <input matInput type="number" formControlName="landAcquired" />
                    <mat-error
                        *ngIf="legalComplianceForm.get('landAcquired')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Status under RFCTLARR Act, 2013</mat-label>
                    <input matInput formControlName="rfctlarrStatus" />
                    <mat-error
                        *ngIf="legalComplianceForm.get('rfctlarrStatus')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Pending Acquisitions</mat-label>
                    <input matInput type="number" formControlName="pendingAcquisitions" />
                    <mat-error
                        *ngIf="legalComplianceForm.get('pendingAcquisitions')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Compensation Status</mat-label>
                    <input matInput formControlName="compensationStatus" />
                    <mat-error
                        *ngIf="legalComplianceForm.get('compensationStatus')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>3A/3D Notifications Status</mat-label>
                    <input matInput formControlName="notificationStatus" />
                    <mat-error
                        *ngIf="legalComplianceForm.get('notificationStatus')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <!-- Environmental Clearances -->
            <h3>Environmental Clearances</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>EIA Status</mat-label>
                    <input matInput formControlName="eiaStatus" />
                    <mat-error *ngIf="legalComplianceForm.get('eiaStatus')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Forest Clearance Status (Stage I/II)</mat-label>
                    <input matInput formControlName="forestClearance" />
                    <mat-error
                        *ngIf="legalComplianceForm.get('forestClearance')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Wildlife Clearance</mat-label>
                    <input matInput formControlName="wildlifeClearance" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>CRZ Clearance</mat-label>
                    <input matInput formControlName="crzClearance" />
                </mat-form-field>
            </div>

            <!-- Utility Shifting -->
            <h3>Utility Shifting Status</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Electrical</mat-label>
                    <input matInput formControlName="utilityElectrical" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Water Supply</mat-label>
                    <input matInput formControlName="utilityWater" />
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Telecommunications</mat-label>
                    <input matInput formControlName="utilityTelecom" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Gas Lines</mat-label>
                    <input matInput formControlName="utilityGas" />
                </mat-form-field>
            </div>

            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Railway Crossings</mat-label>
                <input matInput formControlName="utilityRail" />
            </mat-form-field>

            <!-- Permissions -->
            <h3>Other Permissions</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>ROW Clearances</mat-label>
                    <input matInput formControlName="rowClearance" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Local Authority Permissions</mat-label>
                    <input matInput formControlName="localPermissions" />
                </mat-form-field>
            </div>

            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Tree Cutting Permissions</mat-label>
                <input matInput formControlName="treeCutting" />
            </mat-form-field>

            <mat-form-field class="full-width" appearance="fill">
                <mat-label>NOCs from Authorities</mat-label>
                <textarea matInput rows="2" formControlName="nocAuthorities"></textarea>
            </mat-form-field>

            <!-- Navigation -->
            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!legalComplianceForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="stakeholdersForm">
        <form [formGroup]="stakeholdersForm">
            <ng-template matStepLabel>Stakeholders</ng-template>

            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Project Owner/Client</mat-label>
                    <mat-select formControlName="projectOwner">
                        <mat-option value="Central Government">Central Government</mat-option>
                        <mat-option value="State Government">State Government</mat-option>
                    </mat-select>
                    <mat-error *ngIf="stakeholdersForm.get('projectOwner')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Regulatory Bodies</mat-label>
                    <mat-select formControlName="regulatoryBodies" multiple>
                        <mat-option value="MoRTH">MoRTH</mat-option>
                        <mat-option value="NHAI">NHAI</mat-option>
                        <mat-option value="PWD">PWD</mat-option>
                    </mat-select>
                    <mat-error *ngIf="stakeholdersForm.get('regulatoryBodies')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Funding Agencies</mat-label>
                    <mat-select formControlName="fundingAgencies" multiple>
                        <mat-option value="World Bank">World Bank</mat-option>
                        <mat-option value="ADB">ADB</mat-option>
                        <mat-option value="JICA">JICA</mat-option>
                        <mat-option value="Central Government">Central Government</mat-option>
                        <mat-option value="State Government">State Government</mat-option>
                    </mat-select>
                    <mat-error *ngIf="stakeholdersForm.get('fundingAgencies')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Local Communities</mat-label>
                    <textarea matInput formControlName="localCommunities" rows="2"></textarea>
                    <mat-error *ngIf="stakeholdersForm.get('localCommunities')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Affected Property Owners</mat-label>
                    <textarea matInput formControlName="propertyOwners" rows="2"></textarea>
                    <mat-error *ngIf="stakeholdersForm.get('propertyOwners')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Gram Panchayats/Local Bodies</mat-label>
                    <textarea matInput formControlName="localBodies" rows="2"></textarea>
                    <mat-error *ngIf="stakeholdersForm.get('localBodies')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>
            </div>

            <mat-form-field class="full-width" appearance="fill">
                <mat-label>District Administration</mat-label>
                <textarea matInput formControlName="districtAdmin" rows="2"></textarea>
                <mat-error *ngIf="stakeholdersForm.get('districtAdmin')?.hasError('required')">
                    Required
                </mat-error>
            </mat-form-field>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!stakeholdersForm.valid">Next</button>
            </div>
        </form>
    </mat-step>


    <mat-step [stepControl]="projectTeamsForm">
        <form [formGroup]="projectTeamsForm">
            <ng-template matStepLabel>Project Teams</ng-template>

            <!-- Planning Team -->
            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Planning Team</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Team Structure</mat-label>
                            <textarea matInput formControlName="planningTeamStructure"></textarea>
                            <mat-error *ngIf="projectTeamsForm.get('planningTeamStructure')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Roles and Responsibilities</mat-label>
                            <textarea matInput formControlName="planningRoles"></textarea>
                            <mat-error *ngIf="projectTeamsForm.get('planningRoles')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Contact Information</mat-label>
                        <textarea matInput formControlName="planningContact"></textarea>
                        <mat-error *ngIf="projectTeamsForm.get('planningContact')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Design Team -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Design Team</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Design Consultants</mat-label>
                            <mat-select formControlName="designConsultants" multiple>
                                <mat-option value="DPR Consultant A">DPR Consultant A</mat-option>
                                <mat-option value="DPR Consultant B">DPR Consultant B</mat-option>
                            </mat-select>
                            <mat-error *ngIf="projectTeamsForm.get('designConsultants')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Proof Consultants</mat-label>
                            <input matInput formControlName="proofConsultants" />
                            <mat-error *ngIf="projectTeamsForm.get('proofConsultants')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="half-width" appearance="fill">
                        <mat-label>Authority Engineer</mat-label>
                        <input matInput formControlName="authorityEngineer" />
                        <mat-error *ngIf="projectTeamsForm.get('authorityEngineer')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Contact Information</mat-label>
                        <textarea matInput formControlName="designContact"></textarea>
                        <mat-error *ngIf="projectTeamsForm.get('designContact')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Field Team -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Field Team</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Project Director/Manager</mat-label>
                            <input matInput formControlName="fieldManager" />
                            <mat-error *ngIf="projectTeamsForm.get('fieldManager')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Team Structure</mat-label>
                            <textarea matInput formControlName="fieldStructure"></textarea>
                            <mat-error *ngIf="projectTeamsForm.get('fieldStructure')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Field Engineers</mat-label>
                            <textarea matInput formControlName="fieldEngineers"></textarea>
                            <mat-error *ngIf="projectTeamsForm.get('fieldEngineers')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Supervisors</mat-label>
                            <textarea matInput formControlName="fieldSupervisors"></textarea>
                            <mat-error *ngIf="projectTeamsForm.get('fieldSupervisors')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Contact Information</mat-label>
                        <textarea matInput formControlName="fieldContact"></textarea>
                        <mat-error *ngIf="projectTeamsForm.get('fieldContact')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Acceptance Testing Team -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Acceptance Testing Team</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Independent Engineer</mat-label>
                            <input matInput formControlName="acceptanceEngineer" />
                            <mat-error *ngIf="projectTeamsForm.get('acceptanceEngineer')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Quality Control Engineers</mat-label>
                            <textarea matInput formControlName="qualityEngineers"></textarea>
                            <mat-error *ngIf="projectTeamsForm.get('qualityEngineers')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="half-width" appearance="fill">
                        <mat-label>NABL Testing Laboratories</mat-label>
                        <textarea matInput formControlName="nablLabs"></textarea>
                        <mat-error *ngIf="projectTeamsForm.get('nablLabs')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Contact Information</mat-label>
                        <textarea matInput formControlName="acceptanceContact"></textarea>
                        <mat-error *ngIf="projectTeamsForm.get('acceptanceContact')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>
                </mat-expansion-panel>
            </mat-accordion>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!projectTeamsForm.valid">Next</button>
            </div>
        </form>
    </mat-step>


    <mat-step [stepControl]="contractorsForm">
        <form [formGroup]="contractorsForm">
            <ng-template matStepLabel>Contractors & Vendors</ng-template>

            <mat-accordion>

                <!-- Main Contractor -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Main Contractor</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Company Name</mat-label>
                            <input matInput formControlName="mainContractorName" />
                            <mat-error
                                *ngIf="contractorsForm.get('mainContractorName')?.hasError('required')">Required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Registration/License Number</mat-label>
                            <input matInput formControlName="mainContractorLicense" />
                            <mat-error
                                *ngIf="contractorsForm.get('mainContractorLicense')?.hasError('required')">Required</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>CPWD/PWD Category</mat-label>
                            <input matInput formControlName="mainContractorCategory" />
                            <mat-error
                                *ngIf="contractorsForm.get('mainContractorCategory')?.hasError('required')">Required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Contact Information</mat-label>
                            <textarea matInput formControlName="mainContractorContact"></textarea>
                            <mat-error
                                *ngIf="contractorsForm.get('mainContractorContact')?.hasError('required')">Required</mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Performance History</mat-label>
                        <textarea matInput formControlName="performanceHistory"></textarea>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Bank Guarantee Details</mat-label>
                        <textarea matInput formControlName="bankGuarantee"></textarea>
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Subcontractors -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Subcontractors</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Scope of Work</mat-label>
                            <textarea matInput formControlName="subcontractScope"></textarea>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Company Details</mat-label>
                            <textarea matInput formControlName="subcontractCompany"></textarea>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Contact Information</mat-label>
                        <textarea matInput formControlName="subcontractContact"></textarea>
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Material Suppliers -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Material Suppliers</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Material Type</mat-label>
                            <input matInput formControlName="materialType" />
                            <mat-error
                                *ngIf="contractorsForm.get('materialType')?.hasError('required')">Required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Supplier Name</mat-label>
                            <input matInput formControlName="supplierName" />
                            <mat-error
                                *ngIf="contractorsForm.get('supplierName')?.hasError('required')">Required</mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="half-width" appearance="fill">
                        <mat-label>Quality Certifications (BIS, etc.)</mat-label>
                        <input matInput formControlName="qualityCertifications" />
                    </mat-form-field>

                    <mat-form-field class="half-width" appearance="fill">
                        <mat-label>Contact Information</mat-label>
                        <textarea matInput formControlName="supplierContact"></textarea>
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Approved Sources -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Approved Sources</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Quarry Locations</mat-label>
                            <textarea matInput formControlName="quarryLocations"></textarea>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Borrow Area Details</mat-label>
                            <textarea matInput formControlName="borrowDetails"></textarea>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Royalty Payment Status</mat-label>
                        <textarea matInput formControlName="royaltyStatus"></textarea>
                    </mat-form-field>
                </mat-expansion-panel>
            </mat-accordion>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!contractorsForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="equipmentForm">
        <form [formGroup]="equipmentForm">
            <ng-template matStepLabel>Equipment & Tools</ng-template>

            <mat-accordion>

                <!-- Heavy Equipment -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Heavy Equipment</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Type</mat-label>
                            <input matInput formControlName="heavyType" />
                            <mat-error *ngIf="equipmentForm.get('heavyType')?.hasError('required')">Required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Make/Model</mat-label>
                            <input matInput formControlName="heavyModel" />
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Capacity</mat-label>
                            <input matInput formControlName="heavyCapacity" />
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Ownership</mat-label>
                            <mat-select formControlName="heavyOwnership">
                                <mat-option value="Owned">Owned</mat-option>
                                <mat-option value="Rented">Rented</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Maintenance Schedule</mat-label>
                        <textarea matInput formControlName="maintenanceSchedule"></textarea>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Equipment Deployment Plan</mat-label>
                        <textarea matInput formControlName="deploymentPlan"></textarea>
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Testing Equipment -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Testing Equipment</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Type</mat-label>
                            <input matInput formControlName="testType" />
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Calibration Status</mat-label>
                            <input matInput formControlName="calibrationStatus" />
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>NABL Laboratory Certification</mat-label>
                        <input matInput formControlName="nablCertification" />
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Tools Inventory -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Tools Inventory</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Type and Quantity</mat-label>
                            <input matInput formControlName="toolsQuantity" />
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Condition</mat-label>
                            <input matInput formControlName="toolsCondition" />
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Replacement Schedule</mat-label>
                        <textarea matInput formControlName="replacementSchedule"></textarea>
                    </mat-form-field>
                </mat-expansion-panel>

                <!-- Hot Mix/Batching Plant -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Hot Mix/Batching Plant</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Capacity</mat-label>
                            <input matInput formControlName="plantCapacity" />
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Pollution Control Certification</mat-label>
                            <input matInput formControlName="pollutionCertificate" />
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Calibration Status</mat-label>
                        <input matInput formControlName="plantCalibrationStatus" />
                    </mat-form-field>
                </mat-expansion-panel>

            </mat-accordion>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!equipmentForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="projectControlsForm">
        <form [formGroup]="projectControlsForm">
            <ng-template matStepLabel>Project Controls</ng-template>

            <mat-accordion>

                <!-- Budget -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Budget</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Total Project Cost</mat-label>
                            <input matInput formControlName="totalCost" type="number" />
                            <mat-error
                                *ngIf="projectControlsForm.get('totalCost')?.hasError('required')">Required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Cost Breakdown Structure</mat-label>
                            <textarea matInput formControlName="costBreakdown"></textarea>
                        </mat-form-field>
                    </div>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Funding Sources</mat-label>
                        <input matInput formControlName="fundingSources" />
                    </mat-form-field>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Payment Schedule</mat-label>
                            <textarea matInput formControlName="paymentSchedule"></textarea>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Milestone-based Payments</mat-label>
                            <textarea matInput formControlName="milestonePayments"></textarea>
                        </mat-form-field>
                    </div>
                </mat-expansion-panel>

                <!-- Schedule -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Schedule</mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Work Breakdown Structure</mat-label>
                        <textarea matInput formControlName="wbs"></textarea>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Milestone Dates</mat-label>
                        <textarea matInput formControlName="milestoneDates"></textarea>
                    </mat-form-field>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Critical Path Activities</mat-label>
                            <textarea matInput formControlName="criticalPath"></textarea>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Monsoon Period Planning</mat-label>
                            <textarea matInput formControlName="monsoonPlanning"></textarea>
                        </mat-form-field>
                    </div>
                </mat-expansion-panel>

                <!-- Quality Control -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Quality Control</mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Testing Frequencies</mat-label>
                        <textarea matInput formControlName="testingFrequencies"></textarea>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Acceptance Criteria</mat-label>
                        <textarea matInput formControlName="acceptanceCriteria"></textarea>
                    </mat-form-field>

                    <div class="form-row">
                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Quality Assurance Plan</mat-label>
                            <textarea matInput formControlName="qaPlan"></textarea>
                        </mat-form-field>

                        <mat-form-field class="half-width" appearance="fill">
                            <mat-label>Third-party Quality Audit</mat-label>
                            <textarea matInput formControlName="qualityAudit"></textarea>
                        </mat-form-field>
                    </div>
                </mat-expansion-panel>

                <!-- Risk Management -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Risk Management</mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Risk Register</mat-label>
                        <textarea matInput formControlName="riskRegister"></textarea>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Mitigation Strategies</mat-label>
                        <textarea matInput formControlName="mitigationStrategies"></textarea>
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Contingency Plans</mat-label>
                        <textarea matInput formControlName="contingencyPlans"></textarea>
                    </mat-form-field>
                </mat-expansion-panel>

            </mat-accordion>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!projectControlsForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="multiTenancyForm">
        <form [formGroup]="multiTenancyForm">
            <ng-template matStepLabel>Multi-tenancy Parameters</ng-template>

            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Tenant Identification</mat-label>
                    <input matInput formControlName="tenantId" />
                    <mat-error *ngIf="multiTenancyForm.get('tenantId')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Access Control Levels</mat-label>
                    <mat-select formControlName="accessControl">
                        <mat-option *ngFor="let level of accessLevels" [value]="level">
                            {{ level }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="multiTenancyForm.get('accessControl')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>
            </div>

            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Data Segregation Rules</mat-label>
                <textarea matInput formControlName="dataSegregation"></textarea>
            </mat-form-field>

            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Tenant-specific Configurations</mat-label>
                <textarea matInput formControlName="tenantConfigs"></textarea>
            </mat-form-field>

            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Reporting Requirements</mat-label>
                <textarea matInput formControlName="reportingRequirements"></textarea>
            </mat-form-field>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary"   matStepperNext [disabled]="!multiTenancyForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="indianSpecificForm">
        <form [formGroup]="indianSpecificForm">
            <ng-template matStepLabel>Indian-Specific Requirements</ng-template>

            <!-- GST Compliance -->
            <h3>GST Compliance</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>GST Registration Details</mat-label>
                    <input matInput formControlName="gstDetails" />
                    <mat-error *ngIf="indianSpecificForm.get('gstDetails')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Tax Deduction Requirements</mat-label>
                    <input matInput formControlName="taxDeduction" />
                </mat-form-field>
            </div>

            <!-- Labour Compliance -->
            <h3>Labour Compliance</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Labour License</mat-label>
                    <input matInput formControlName="labourLicense" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Workmen Compensation Insurance</mat-label>
                    <input matInput formControlName="workmenInsurance" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>PF/ESI Registration</mat-label>
                    <input matInput formControlName="pfEsi" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Labour Welfare Provisions</mat-label>
                    <textarea matInput formControlName="labourWelfare"></textarea>
                </mat-form-field>
            </div>

            <!-- Contract Type -->
            <h3>Contract Type</h3>
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Contract Type</mat-label>
                <mat-select formControlName="contractType" required>
                    <mat-option value="EPC">EPC</mat-option>
                    <mat-option value="Item Rate">Item Rate</mat-option>
                    <mat-option value="BOT/DBFOT">BOT/DBFOT</mat-option>
                    <mat-option value="HAM">HAM</mat-option>
                </mat-select>
                <mat-error *ngIf="indianSpecificForm.get('contractType')?.hasError('required')">
                    Required
                </mat-error>
            </mat-form-field>

            <!-- Dispute Resolution -->
            <h3>Dispute Resolution Mechanism</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Arbitration Setup</mat-label>
                    <input matInput formControlName="arbitration" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Conciliation Committee</mat-label>
                    <input matInput formControlName="conciliation" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Dispute Review Board</mat-label>
                    <input matInput formControlName="disputeBoard" />
                </mat-form-field>
            </div>

            <!-- Local Content Requirements -->
            <h3>Local Content Requirements</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Make in India Compliance</mat-label>
                    <input matInput formControlName="makeInIndia" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>MSME Participation</mat-label>
                    <input matInput formControlName="msmeParticipation" />
                </mat-form-field>
            </div>

            <!-- Maintenance Period -->
            <h3>Maintenance Period</h3>
            <div class="form-row">
                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Defect Liability Period</mat-label>
                    <input matInput formControlName="defectLiability" />
                </mat-form-field>

                <mat-form-field class="half-width" appearance="fill">
                    <mat-label>Routine Maintenance Requirements</mat-label>
                    <textarea matInput formControlName="routineMaintenance"></textarea>
                </mat-form-field>

                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Performance-based Maintenance</mat-label>
                    <textarea matInput formControlName="performanceMaintenance"></textarea>
                </mat-form-field>
            </div>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!indianSpecificForm.valid">Next</button>
            </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="documentationForm">
        <form [formGroup]="documentationForm">
          <ng-template matStepLabel>Documentation</ng-template>
      
          <div class="form-row">
            <mat-form-field class="half-width" appearance="fill">
              <mat-label>Contract Documents</mat-label>
              <input matInput formControlName="contractDocs" />
              <mat-error *ngIf="documentationForm.get('contractDocs')?.hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
      
            <mat-form-field class="half-width" appearance="fill">
              <mat-label>Detailed Project Report (DPR)</mat-label>
              <input matInput formControlName="dpr" />
              <mat-error *ngIf="documentationForm.get('dpr')?.hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
      
            <mat-form-field class="half-width" appearance="fill">
              <mat-label>GFC Drawings</mat-label>
              <input matInput formControlName="gfcDrawings" placeholder="Upload a DWG/DXF or paste a link" />
              <span matSuffix class="drawing-actions">
                <label class="drawing-btn" [class.disabled]="drawingUploading.gfcDrawings" title="Upload DWG/DXF">
                  <i class="bi" [ngClass]="drawingUploading.gfcDrawings ? 'bi-hourglass-split' : 'bi-upload'"></i>
                  <input type="file" hidden [accept]="cadAccept" [disabled]="!!drawingUploading.gfcDrawings" (change)="uploadDrawing('gfcDrawings', $event)" />
                </label>
                <button type="button" class="drawing-btn" *ngIf="canViewDrawing('gfcDrawings')" (click)="viewDrawing('gfcDrawings')" title="View drawing">
                  <i class="bi bi-eye"></i>
                </button>
              </span>
              <mat-hint *ngIf="drawingError.gfcDrawings" class="drawing-error">{{ drawingError.gfcDrawings }}</mat-hint>
            </mat-form-field>
      
            <mat-form-field class="half-width" appearance="fill">
              <mat-label>Monthly Progress Reports</mat-label>
              <input matInput formControlName="progressReports" />
            </mat-form-field>
      
            <mat-form-field class="half-width" appearance="fill">
              <mat-label>Quality Assurance Plan</mat-label>
              <input matInput formControlName="qap" />
            </mat-form-field>
      
            <mat-form-field class="half-width" appearance="fill">
              <mat-label>Test Reports</mat-label>
              <input matInput formControlName="testReports" />
            </mat-form-field>
      
            <mat-form-field class="half-width" appearance="fill">
              <mat-label>As-built Drawings</mat-label>
              <input matInput formControlName="asBuiltDrawings" placeholder="Upload a DWG/DXF or paste a link" />
              <span matSuffix class="drawing-actions">
                <label class="drawing-btn" [class.disabled]="drawingUploading.asBuiltDrawings" title="Upload DWG/DXF">
                  <i class="bi" [ngClass]="drawingUploading.asBuiltDrawings ? 'bi-hourglass-split' : 'bi-upload'"></i>
                  <input type="file" hidden [accept]="cadAccept" [disabled]="!!drawingUploading.asBuiltDrawings" (change)="uploadDrawing('asBuiltDrawings', $event)" />
                </label>
                <button type="button" class="drawing-btn" *ngIf="canViewDrawing('asBuiltDrawings')" (click)="viewDrawing('asBuiltDrawings')" title="View drawing">
                  <i class="bi bi-eye"></i>
                </button>
              </span>
              <mat-hint *ngIf="drawingError.asBuiltDrawings" class="drawing-error">{{ drawingError.asBuiltDrawings }}</mat-hint>
            </mat-form-field>
      
            <mat-form-field class="half-width" appearance="fill">
              <mat-label>O&M Manuals</mat-label>
              <input matInput formControlName="omManuals" />
            </mat-form-field>
          </div>
      
          <div class="form-actions">
            <button mat-button matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" [disabled]="!documentationForm.valid">Sumit</button>
          </div>
        </form>
      </mat-step>
      

</mat-horizontal-stepper>